export interface LanguageConfig {
  code: string;
  name: string;
  flag: string;
  url: string;
  isDefault?: boolean;
}

export const supportedLanguages: LanguageConfig[] = [
  {
    code: 'en',
    name: 'English',
    flag: '🇺🇸',
    url: 'https://codesplashdesigns.com',
    isDefault: true
  },
  {
    code: 'es',
    name: 'Español',
    flag: '🇪🇸',
    url: 'https://es.codesplashdesigns.com'
  },
  {
    code: 'fr',
    name: 'Français',
    flag: '🇫🇷',
    url: 'https://fr.codesplashdesigns.com'
  },
  {
    code: 'de',
    name: 'Deutsch',
    flag: '🇩🇪',
    url: 'https://de.codesplashdesigns.com'
  },
  {
    code: 'pt',
    name: 'Português',
    flag: '🇧🇷',
    url: 'https://pt.codesplashdesigns.com'
  }
];

export const getHreflangForPage = (currentPath: string): Array<{lang: string; url: string}> => {
  const baseUrl = 'https://codesplashdesigns.com';
  
  return supportedLanguages.map(lang => ({
    lang: lang.code,
    url: lang.isDefault ? `${baseUrl}${currentPath}` : `${lang.url}${currentPath}`
  }));
};

export const getLanguageByCode = (code: string): LanguageConfig | undefined => {
  return supportedLanguages.find(lang => lang.code === code);
};

export const getDefaultLanguage = (): LanguageConfig => {
  return supportedLanguages.find(lang => lang.isDefault) || supportedLanguages[0];
};

// SEO-friendly language names for meta tags
export const languageNames = {
  en: 'English',
  es: 'Spanish',
  fr: 'French',
  de: 'German',
  pt: 'Portuguese'
};

// Country-specific settings
export const countrySettings = {
  US: {
    currency: 'USD',
    phoneFormat: '+1',
    addressFormat: 'US'
  },
  ES: {
    currency: 'EUR',
    phoneFormat: '+34',
    addressFormat: 'ES'
  },
  FR: {
    currency: 'EUR',
    phoneFormat: '+33',
    addressFormat: 'FR'
  },
  DE: {
    currency: 'EUR',
    phoneFormat: '+49',
    addressFormat: 'DE'
  },
  BR: {
    currency: 'BRL',
    phoneFormat: '+55',
    addressFormat: 'BR'
  }
}; 